<template>
  <div>
    <h3 class="header">{{title}}</h3>

    <div class="title">
      <div style="color:gray;margin:10px;">报名费 : 1980元/人 (含教材资料费,不含交通食宿费)</div>
      <!-- <div style="font-size:12px;margin:10px;color:gray">{{desc}}</div> -->
      <!-- <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>

        <van-field label="姓名" clearable v-model="question.username" placeholder="请输入真实姓名" />
      </van-cell-group>-->
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">姓名:</span>
        <span>
          <van-field
            style="width:150%"
            clearable
            v-model="question.username"
            placeholder="请输入真实姓名"
          />
        </span>
      </van-cell-group>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">银行:</span>
        <span>
          <van-field
            style="width:150%"
            clearable
            v-model="question.bank_name"
            placeholder="请输入银行名称"
          />
        </span>
      </van-cell-group>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">部门:</span>
        <span>
          <van-field style="width:150%" clearable v-model="question.dep" placeholder="请输入部门" />
        </span>
      </van-cell-group>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">岗位:</span>
        <span>
          <van-field style="width:150%" clearable v-model="question.position" placeholder="请输入岗位" />
        </span>
      </van-cell-group>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">联系方式:</span>
        <span>
          <van-field style="width:150%" clearable v-model="question.mobile" placeholder="请输入手机号码" />
        </span>
      </van-cell-group>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">选择公开课</h6>
        <van-radio-group
          style="margin:5px 0"
          v-model="course_name"
          v-for="(item,index) in option1"
          :key="index"
        >
          <van-radio :name="item.id">{{item.name}}</van-radio>
        </van-radio-group>
        <!-- <van-dropdown-menu>
          <van-dropdown-item v-model="course_name" :options="option1" />
        </van-dropdown-menu>-->
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">酒店安排</h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;" v-model="question.is_hotel">
            <van-radio class="radio" name="1">锐道协助预定(默认会场酒店)</van-radio>
            <van-radio class="radio" name="2">自行安排</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">房型</h6>
        <div style="display:flex;" v-if="question.is_hotel == 1">
          <van-radio-group style="margin:0;padding:0;" v-model="question.hotel_type">
            <van-radio class="radio" name="1">标准间</van-radio>
            <van-radio class="radio" name="2">大床房</van-radio>
            <van-radio class="radio" name="3">行政房</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">酒店入住日期</h6>
        <span>
          <div
            @click="focus"
            style="height:35px;line-height:35px;font-size:15px;border:1px solid #DCDFE6;padding:0 15px;"
          >
            <van-icon name="vip-card-o" />
            {{question.hotel_checkin}}
          </div>
        </span>
        <van-datetime-picker
          v-model="hotel_checkin"
          v-if="checkin"
          type="date"
          @change="Change"
          @cancel="cancel"
          @confirm="checkins"
          :formatter="formatter"
          :min-date="minDate"
        />
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">酒店离开日期</h6>
        <span>
          <div
            @click="focu"
            style="height:35px;line-height:35px;font-size:15px;border:1px solid #DCDFE6;padding:0 15px;"
          >
            <van-icon name="vip-card-o" />
            {{question.hotel_checkout}}
          </div>
        </span>
        <van-datetime-picker
          v-model="hotel_checkout"
          v-if="checkout"
          @change="Changes"
          type="date"
          @cancel="cancels"
          @confirm="checkouts"
          :formatter="formatter"
          :min-date="minDate"
        />
      </div>
      <h6 style="margin:20px 0 0px 0;padding:0;">备注</h6>
      <van-cell-group>
        <van-field
          style="border:1px solid rgb(220, 223, 230)"
          v-model="question.remark"
          type="textarea"
          placeholder="同行人数"
          rows="1"
          autosize
        />
      </van-cell-group>
      <br />

      <div style="display:flex;justify-content: center;">
        <van-button type="primary" class="submit" @click="submitAnswer" :disabled="disabled">报名</van-button>
      </div>
      <div class="footer">
        <br />
        {{ad}}
        <br />@锐道咨询
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disabled: false,
      course_name: 23,
      hotel_checkin: new Date(2019, 10, 1),
      hotel_checkout: new Date(2019, 10, 1),
      checkin: false,
      checkout: false,
      title: "公开课参会报名",
      questions: "",
      // desc:
      //   "为了改进和提升培训服务质量,请将您听后的感受和要求反馈给我们,您的认真作答将有助于我们进一步改善培训工作",
      ad: "",
      question: {
        hotel_checkout: "",
        id: "2",

        is_hotel: "2",
        hotel_type: "",
        username: "",
        dep: "",
        bank_name: "",
        position: "",
        hotel_checkin: "",
        mobile: "",
        remark: " "
      },

      course: "",
      minDate: new Date(),
      teacher: "",
      option1: []
    };
  },
  methods: {
    toDou(m) {
      return m < 10 ? "0" + m : m;
    },
    format(newData) {
      var time = new Date(newData);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y + "-" + this.toDou(m) + "-" + this.toDou(d);
    },
    cancels() {
      this.checkout = false;
    },
    cancel() {
      this.checkin = false;
    },
    Change() {
      var date = this.hotel_checkin;
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      this.question.hotel_checkin =
        date.getFullYear() + "-" + month + "-" + strDate;
    },
    Changes() {
      var date = this.hotel_checkout;
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      this.question.hotel_checkout =
        date.getFullYear() + "-" + month + "-" + strDate;
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
      return value;
    },
    checkins(value) {
      this.checkin = false;
    },
    checkouts(value) {
      this.checkout = false;
    },
    focus() {
      this.checkin = true;
    },
    focu() {
      this.checkout = true;
    },
    submitAnswer() {
      if (
        this.question.username == "" ||
        this.question.customer_name == "" ||
        this.question.dep == "" ||
        this.question.position == "" ||
        this.question.mobile == ""
      ) {
        this.$toast({
          message: "请填写完整信息",
          type: "waring"
        });
      } else {
        this.question.id = this.course_name;
        this.disabled = true;
        this.$http.post("/oa/wxmeeting/addReport", this.question).then(res => {
          if (res.data.code == 200) {
            this.$toast({
              message: res.data.message,
              type: "success",
              duration: 10000
            });
            this.question = {};
            this.multi = [];
            this.disabled = false;
          } else {
            this.$toast({
              message: res.data.message,
              type: "waring",
              duration: 10000
            });
            this.disabled = false;
          }
        });
      }
    }
  },
  created() {
    this.question.hotel_checkout = this.format(new Date());
    this.question.hotel_checkin = this.format(new Date());
    document.title = "锐道咨询公开课参会报名";
    if (this.$route.query.id) {
      var id = this.$route.query.id;
      this.$http.post("/oa/wxmeeting/reportItem?id=" + id).then(res => {
        // this.course = res.data.data.course;
        for (var i of res.data.data) {
          i.value = i.id;
          this.course_name = i.id;

          i.text = i.name;
        }
        if (res.data.data.title) {
          this.title = res.data.data.title;
        }
        this.option1 = res.data.data;
        // this.title = res.data.data.title;
        // this.teacher = res.data.data.teacher;
        // this.$route.query.id = res.data.data.id;
      });
      // this.$http.get("/oa/wxzhuzi/multi_wenjuan?id=" + id).then(res => {

      // });
    } else {
      const id = 23 + "-" + 28;
      this.$http.post("/oa/wxmeeting/reportItem?id=" + id).then(res => {
        for (var i of res.data.data) {
          i.value = i.id;
          i.text = i.name;
        }
        if (res.data.data.title) {
          this.title = res.data.data.title;
        }
        this.option1 = res.data.data;
      });
    }
  }
};
</script>

<style scoped>
.title {
  width: 90%;
  margin: 0 0 0 20px;
  font-size: 12px;
}
.header {
  width: 100%;
  text-align: center;
  margin: 10px 0 0 0;
}
.radio {
  margin: 20px 0 0 0;
}
.submit {
  border-radius: 10px;

  width: 100px;
  height: 40px;
}
.margin {
  margin: 10px;
}
.footer {
  text-align: center;
  color: gray;
  font-size: 14px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/open.vue